import React from 'react'

const Loading = () => {
    return (
        <div className=" h-100 d-flex justify-content-center py-3 my-5">
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}

export default Loading
